type DotPrefix<T extends string> = T extends '' ? '' : `.${T}`

export type GetEveryObjectPaths<T, MaxDepth extends number = 5, CurrentDepth extends ReadonlyArray<unknown> = []> = (
    CurrentDepth['length'] extends MaxDepth
        ? ''
        : T extends object
          ? {
                [K in Exclude<keyof T, symbol>]: `${K}${DotPrefix<
                    GetEveryObjectPaths<T[K], MaxDepth, [...CurrentDepth, unknown]>
                >}`
            }[Exclude<keyof T, symbol>]
          : ''
) extends infer D
    ? Extract<D, string>
    : never
export type DeepPartial<T> = {
    [P in keyof T]?: T[P] extends Array<infer I> ? Array<DeepPartial<I>> : DeepPartial<T[P]>
}
export type PartialRecord<K extends PropertyKey, T> = {
    [P in K]?: T
}

/** The member of `options` equal to `value`, typed as the option union. Undefined when `value` is none of them. */
export const findOption = <T>(options: readonly T[], value: unknown): T | undefined =>
    options.find((option) => option === value)

/** The keys of an object typed as its own keys. Use it on objects built from a literal, which carry no other keys. */
export const typedKeys = <T extends object>(value: T): Extract<keyof T, string>[] =>
    // eslint-disable-next-line typescript/no-unsafe-type-assertion -- Object.keys returns string[] by design, and a literal object has exactly its declared keys
    Object.keys(value) as Extract<keyof T, string>[]

/** The entries of an object typed by its own keys and values, under the same condition as typedKeys. */
export const typedEntries = <T extends object>(value: T): { [K in keyof T]-?: [K, T[K]] }[Extract<keyof T, string>][] =>
    // eslint-disable-next-line typescript/no-unsafe-type-assertion -- Object.entries returns string keys by design, and a literal object has exactly its declared keys
    Object.entries(value) as { [K in keyof T]-?: [K, T[K]] }[Extract<keyof T, string>][]
